
import { IGlobalState } from "@/store";
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import appList from "./appList.vue";

export default defineComponent({
  components: {
    appList
  },
  setup() {
      const store = useStore<IGlobalState>();
      const router = useRouter();
      const state = reactive({
          activeName:'1',
          userId: computed(() => store.state.user.id),
          shelfStateList:[
            {
              name:1,
              label:'已上架'
            },
            {
              name:3,
              label:'未上架'
            },
            {
              name:2,
              label:'已下架'
            }
          ]
      });
      const appListRef = ref<any>(null);
    // 获取关键字
    const keyWord = computed({
      get: () => store.state.frontApp.keyWord,
      set: (val) => {
        store.state.frontApp.keyWord = val;
      },
    });

    // 获取当前状态
    const shelfState = computed({
      get: () => store.state.frontApp.shelfState,
      set: (val) => {
        store.state.frontApp.shelfState = val;
      },
    });
    /**
     * 当tab标签被点击时触发
     */
    function handleClick(tab: any){
      state.activeName = tab.props.name;
    }
    function addApp(){
      router.push("/addapp");
    }
    /**
     * 搜索
     */
    function handleSearch(){
      appListRef.value.handleSearch();
    }
    return {
        ...toRefs(state),
        keyWord,
        appListRef,
        shelfState,
        handleClick,
        addApp,
        handleSearch
    }
  }
});
